export default {
  profile: '個人中心',
  settings: '系統設置',
};
